export default {
  styleOverrides: {
    root: {
      backgroundColor: "rgb(255, 255, 255)",
      color: "#2E2E38",
      borderBottom: "1px #EAEAF2 solid",
      boxShadow: "none",
    },
  },
};
